enum USER_ROLES {
  PORTAL_USER = "PortalUser",
  ADMIN = "Admin",
  SUPER_ADMIN = "SuperAdmin",
  POSTER = "Poster",
  INQUIRY_ONLY = "InquiryOnly",
  SETUP = "Setup",
  INTEGRATION_RECEPTIONIST = "IntegrationReceptionist",
}

export default USER_ROLES;
